import i18n from '@/main';
import formattersUtil from '@/utils/formatters';

const BASE_I18N_TABLE = 'warehouse.messages.inbound_invoices_table';

export function translate(key, params = {}) {
    return i18n.t(`${BASE_I18N_TABLE}.${key}`, params);
}

export function translateProduto(codigo) {
    if (!codigo) return '-';
    const key = `warehouse.messages.${codigo.toLowerCase()}`;
    const translated = i18n.t(key);
    return translated !== key ? translated : codigo;
}

export function translateOperationType(codigo) {
    if (!codigo) return '-';
    const mapa = {
        NOTA_FISCAL: 'warehouse.messages.grain_reception_from_producers',
        TRANSFERENCIA_INTERNA: 'warehouse.messages.internal_transfer',
        TRANSFERENCIA_TITULARIDADE: 'warehouse.messages.ownership_transfer',
        EXPORTACAO: 'warehouse.messages.external_transfer',
        EMPRESTIMO: 'warehouse.messages.loan_transfer_between_partners'
    };
    return mapa[codigo] ? i18n.t(mapa[codigo]) : codigo;
}

export function formatVolume(value, locale) {
    if (value === null || value === undefined) return '-';
    return formattersUtil.minFormatNumber(value, 2, locale || i18n.locale);
}

export function formatDateTime(dateTime) {
    if (!dateTime) return '-';
    const [data, hora] = formattersUtil.splitApiDateTimeForTable(dateTime, i18n.locale);
    return `<div class="cell-text">${data}</div><div class="cell-text--secondary"><i class="mdi mdi-clock-outline"></i> ${hora}</div>`;
}
